/**
 *
 * Home
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import ModalCustom from "components/ModalCustom"
import Layout from "components/Layout"
import iconLupa from "images/lupa.svg"
import { Button, Divider, Input, Pagination, Select, Spin, Tooltip } from "antd"
import {
  PlusOutlined,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons"
import { orderBy } from "lodash"
import CompaniesTable from "components/CompaniesTable"

import saga from "./saga"
import {
  getCompaniesInfoWatcher,
  getCompaniesWatcher,
  goCompanyWatcher,
  searchWatcher,
} from "./actions"
import {
  makeSelectCompanies,
  makeSelectIsLoading,
  makeSelectOptions,
  makeSelectSearchLoading,
  makeSelectSearchResult,
} from "./selectors"
import reducer from "./reducer"
import { ROLE_MANDU_SUPER_ADMIN } from "../../../../utils/constants"
import "./index.less"
import { LOCAL_ACTIVE_ROL } from "../../../../utils/storage"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class Home extends React.Component {
  state = {
    modalSearch: false,
    modalSearchTotal: 0,
    modalSearchValue: "",
    modalSearchPageSize: 10,
    modalSearchPage: 1,
    modalSearchFiltered: false,
    searchHistoryMeasurement: "",
    selectedLicense: undefined,
    selectedModule: undefined,
  }

  componentDidMount() {
    this.props.getCompaniesInfo()
    this.props.getCompanies()
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.search_result &&
      nextProps.search_result.total >= 0 &&
      nextProps.search_result.total != this.props.search_result.total
    ) {
      this.setState({ modalSearchTotal: nextProps.search_result.total })
    }
  }

  onChangeModalPagination = (page) => {
    this.setState({ modalSearchPage: page }, () => {
      this.modalSearch()
    })
  }

  modalSearch = () => {
    this.setState({ modalSearchFiltered: true })
    this.props.search({
      per_page: this.state.modalSearchPageSize,
      page: this.state.modalSearchPage,
      value: this.state.modalSearchValue,
    })
  }

  showDataBySearch = () => {
    const {
      searchHistoryMeasurement,
      selectedLicense = "",
      selectedModule = "",
    } = this.state

    if (searchHistoryMeasurement || selectedLicense || selectedModule) {
      return this.props.companies.filter(
        (item) =>
          item.name
            .toLowerCase()
            .includes(searchHistoryMeasurement.toLocaleLowerCase()) &&
          item.license.toLowerCase().includes(selectedLicense.toLowerCase()) &&
          item.platforms_name
            .toLowerCase()
            .includes(selectedModule.toLowerCase())
      )
    }

    return Array.isArray(this.props.companies)
      ? orderBy(this.props.companies, ["name"])
      : []
  }

  render() {
    const {
      modalSearch,
      modalSearchTotal,
      modalSearchValue,
      modalSearchFiltered,
      searchHistoryMeasurement,
    } = this.state
    const { options, isLoading, search_loading, search_result } = this.props
    return (
      <Layout>
        <Helmet>
          <title>Empresas</title>
          <meta name="description" content="Compañías" />
        </Helmet>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="AdministratorCompaniesHome"
            style={{ height: "100%" }}>
            <div className="AdministratorCompaniesHome-header">
              <div className="AdministratorCompaniesHome-header-title">
                <span>
                  Empresas{" "}
                  <span className="color-gray-low" style={{ fontWeight: 400 }}>
                    ({this.showDataBySearch().length})
                  </span>
                </span>
              </div>
              <div
                className="AdministratorCompaniesHome-header-buttons"
                style={{
                  display:
                    LOCAL_ACTIVE_ROL() == ROLE_MANDU_SUPER_ADMIN.toString()
                      ? "flex"
                      : "none",
                }}>
                <Tooltip placement="bottomRight" title="Buscar">
                  <Button
                    size="default"
                    type="link"
                    onClick={() => this.setState({ modalSearch: true })}>
                    <img src={iconLupa} />
                  </Button>
                </Tooltip>
                <Tooltip placement="bottomRight" title="Crear empresa">
                  <Button
                    className="blueButton"
                    size="default"
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => this.props.history.push("/companies/new")}
                  />
                </Tooltip>
              </div>
            </div>

            <div className="AdministratorCompaniesHome-body">
              <div className="AdministratorCompaniesHome-body-filters">
                <Input
                  placeholder="Buscar..."
                  style={{ width: 300 }}
                  value={searchHistoryMeasurement}
                  onChange={(e) =>
                    this.setStateFrom(
                      "searchHistoryMeasurement",
                      e.target.value
                    )
                  }
                  suffix={
                    searchHistoryMeasurement ? (
                      <CloseCircleOutlined
                        style={{
                          cursor: "pointer",
                          color: "white",
                          background: "rgba(0, 0, 0, 0.25)",
                          borderRadius: "50%",
                        }}
                        onClick={() =>
                          this.setStateFrom("searchHistoryMeasurement", "")
                        }
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                />
                <div className="AdministratorCompaniesHome-body-filters-right">
                  <Select
                    allowClear
                    onChange={(e) => this.setStateFrom("selectedLicense", e)}
                    placeholder="Seleccionar licencia"
                    style={{ width: 200, marginRight: "1rem" }}>
                    {options?.licenses?.map((s, sI) => (
                      <Option key={sI} value={s.name}>
                        {s.name}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    allowClear
                    onChange={(e) => this.setStateFrom("selectedModule", e)}
                    placeholder="Seleccionar módulo"
                    style={{ width: 200 }}>
                    {options &&
                      options.PlatformHasModules &&
                      options.PlatformHasModules.map((mM, mMI) => (
                        <Option key={mMI} value={mM.name}>
                          {mM.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              </div>
              <div className="AdministratorCompaniesHome-body-content">
                {isLoading ? (
                  <div className="loadingSpin">
                    <Spin size="large" />
                  </div>
                ) : (
                  <CompaniesTable
                    goCompany={this.props.goCompany}
                    isLoading={isLoading}
                    companies={this.showDataBySearch()}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ModalCustom
          onCancel={() =>
            this.setState({
              modalSearch: false,
              modalSearchFiltered: false,
              modalSearchValue: "",
            })
          }
          title="Buscar"
          width={700}
          modalOpen={modalSearch}
          showOnlyAccept
          textButton="Cerrar"
          onOk={() =>
            this.setState({
              modalSearch: false,
              modalSearchFiltered: false,
              modalSearchValue: "",
            })
          }>
          <div className="AdministratorCompaniesHome-modal">
            <Input
              placeholder="Buscar..."
              style={{ width: 300 }}
              value={modalSearchValue}
              onChange={(value) =>
                this.setState({ modalSearchValue: value.target.value }, () =>
                  this.modalSearch()
                )
              }
              suffix={
                modalSearchValue ? (
                  <CloseCircleOutlined
                    style={{
                      cursor: "pointer",
                      color: "white",
                      background: "rgba(0, 0, 0, 0.25)",
                      borderRadius: "50%",
                    }}
                    onClick={() =>
                      this.setState({
                        modalSearchValue: "",
                        modalSearchFiltered: false,
                      })
                    }
                    type="close-circle"
                  />
                ) : (
                  <SearchOutlined />
                )
              }
            />

            <Divider
              style={{ width: "calc(100% + 48px)", margin: "20px -24px" }}
            />

            {!modalSearchFiltered || modalSearchValue.length === 0 ? (
              <div
                style={{
                  padding: "100 20",
                  textAlign: "center",
                  color: "#9F9F9F",
                }}>
                Aún no se cuenta con una búsqueda.
              </div>
            ) : (
              <Fragment>
                <span className="color-gray-low" style={{ display: "block" }}>
                  {modalSearchTotal || 0} resultados
                </span>
                <div className="AdministratorCompaniesHome-modal-table">
                  <div className="AdministratorCompaniesHome-modal-table-header">
                    <div>Colaborador</div>
                    <div>Correo electrónico</div>
                    <div>DNI</div>
                    <div>Empresa</div>
                  </div>
                  <div className="AdministratorCompaniesHome-modal-table-body">
                    {search_loading ? (
                      <div className="loadingSpin">
                        <Spin size="large" />
                      </div>
                    ) : search_result && search_result.data ? (
                      search_result.data.length > 0 ? (
                        search_result.data.map((sR, sI) => (
                          <div
                            className="AdministratorCompaniesHome-modal-table-body-row"
                            key={sI}>
                            <div>
                              <Tooltip placement="bottom" title={sR.full_name}>
                                {sR.full_name}
                              </Tooltip>
                            </div>
                            <div>{sR.email}</div>
                            <div>{sR.document}</div>
                            <div>
                              <Tooltip
                                placement="bottom"
                                title={sR.company_name}>
                                {sR.company_name}
                              </Tooltip>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            padding: 20,
                            textAlign: "center",
                            color: "#9F9F9F",
                          }}>
                          No hay resultados para la búsqueda
                        </div>
                      )
                    ) : null}
                  </div>
                  <Pagination
                    onChange={this.onChangeModalPagination}
                    total={modalSearchTotal || 0}
                  />
                </div>
              </Fragment>
            )}
          </div>
        </ModalCustom>
      </Layout>
    )
  }
}

Home.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  companies: makeSelectCompanies(),
  options: makeSelectOptions(),
  search_loading: makeSelectSearchLoading(),
  search_result: makeSelectSearchResult(),
})

function mapDispatchToProps(dispatch) {
  return {
    getCompanies: (params) => dispatch(getCompaniesWatcher(params)),
    getCompaniesInfo: (params) => dispatch(getCompaniesInfoWatcher(params)),
    search: (params) => dispatch(searchWatcher(params)),
    goCompany: (params) => dispatch(goCompanyWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({
  key: "AdministratorCompaniesHome",
  reducer,
})
const withSaga = injectSaga({ key: "AdministratorCompaniesHome", saga })

export default compose(withReducer, withSaga, withConnect)(Home)
